interface IconToggleDropdownProps {
  className?: string;
}

export default function IconToggleDropdown({ className }: IconToggleDropdownProps) {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask id="path-1-inside-1_10483_3138" fill="white">
        <path d="M5.37109 0L10.7422 5.92886L5.37109 11.8577L1.75065e-06 5.92886L5.37109 0Z" />
      </mask>
      <path
        d="M5.37109 11.8577L4.69971 12.5988L5.37109 13.3399L6.04248 12.5988L5.37109 11.8577ZM10.0708 5.18775L4.69971 11.1166L6.04248 12.5988L11.4136 6.66997L10.0708 5.18775ZM6.04248 11.1166L0.671388 5.18775L-0.671385 6.66997L4.69971 12.5988L6.04248 11.1166Z"
        fill="white"
        mask="url(#path-1-inside-1_10483_3138)"
      />
    </svg>
  );
}
